import _ from 'lodash';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { caseInsensitiveSelectFilterOption } from '../../../helpers/caseInsensitiveSelectFilterOption';
import { Option, Select } from '../../../system/components/Select';

interface Props {
  form: WrappedFormUtils;
  onSelect: (value: number, field: string) => void;
  initialValue?: number | null;
}

const Styles = styled.div`
  .no-margin-bottom {
    margin-bottom: 0;
  }
`;

const twoDigitDay = (day: number): string => {
  return day < 10 ? `0${day}` : `${day}`;
};

export const SelectPatientBirthDay: FC<Props> = ({ form, onSelect, initialValue }): JSX.Element => (
  <Styles>
    <Form.Item className="no-margin-bottom">
      {form.getFieldDecorator('birthDay', { initialValue: initialValue })(
        <Select
          filterOption={caseInsensitiveSelectFilterOption}
          placeholder="Day"
          onChange={(v: number) => onSelect(v, 'day')}
          showAction={['focus', 'click']}
          showSearch
        >
          {_.range(1, 32).map(day => (
            <Option value={day} key={`day-${day}`}>
              {twoDigitDay(day)}
            </Option>
          ))}
        </Select>
      )}
    </Form.Item>
  </Styles>
);
